export default "__VITE_ASSET__BblffL61__"